module.exports = __webpack_public_path__ + "img/va.21913d78.svg";